import { Component, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { Title, Meta } from "@angular/platform-browser";
import {
    ActivatedRoute,
    NavigationEnd,
    ParamMap,
    Router,
} from "@angular/router";
import { Location } from "@angular/common";
import { Subject, Subscription, forkJoin } from "rxjs";
import { AppService } from "src/app/app.service";
import { EmitterService } from "src/app/EmitterService";
import { filter, takeUntil } from "rxjs/operators";
import { Navbar } from "../components/layouts/navbar/navbar.component";

@Component({
    selector: "app-template-page",
    templateUrl: "./template-page.component.html",
    styleUrls: ["./template-page.component.scss"],
})
export class TemplatePageComponent implements OnInit, OnDestroy {
    imageLoaded = false;
    fetchinData = true;
    subscription: Subscription;
    mainData: any;
    currentRoute: string;
    currentMenuItem: any;
    ContentData: any;
    currentContentData: any;
    private ngUnsubscribe = new Subject();
    @ViewChild(Navbar)
    childComponent: Navbar;

    constructor(
        private route: ActivatedRoute,
        private location: Location,
        private appService: AppService,
        private router: Router,
        private emitterService: EmitterService,
        private titleService: Title,
        private metaService: Meta
    ) {}

    ngOnInit() {
        this.subscription = this.emitterService.currentMessage.subscribe(
            (message) => {
                if (message === true) {
                    this.FetchData();
                }
            }
        );

        this.router.events.pipe(
            filter(event => event instanceof NavigationEnd),
            takeUntil(this.ngUnsubscribe)
        ).subscribe(() => {
            if (!this.fetchinData) {
                this.fetchinData = true;
                this.currentContentData = null;
                this.FetchData();
            }
        });
    }

    ngOnDestroy() {
        this.ngUnsubscribe.next(null);
        this.ngUnsubscribe.complete();
        this.subscription.unsubscribe();
    }

    FetchData() {
        forkJoin([this.appService.getContents()])
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe((response: any) => {
                console.log(response, "response FetchData");

                this.ContentData = response[0].data;

                let mData = localStorage.getItem("mainData");

                if (mData != null) {
                    this.mainData = JSON.parse(mData);
                    this.currentRoute = this.route.snapshot.url.join("/");

                    let currentMenu = this.mainData.SiteMapList.filter(
                        (item) => item.MenuUrl && (item.MenuUrl.trim() == this.currentRoute || item.MenuUrl.trim() == "/" + this.currentRoute)
                    );

                    if (currentMenu.length != 0) {
                        this.currentMenuItem = currentMenu[0];
                    }

                    if (this.currentMenuItem) {
                        let ccData = this.ContentData.filter(
                            (x) => x.MenuCode == this.currentMenuItem.MenuCode
                        );

                        if (ccData.length != 0) {
                            this.currentContentData = ccData[0];
                            
                            // Set SEO Meta Tags
                            const pageTitle = this.currentContentData.TitleBn || this.currentContentData.TitleEn || this.currentMenuItem.DisplayNameBangla || this.currentMenuItem.MenuName;
                            if (pageTitle) {
                                this.titleService.setTitle(`${pageTitle} | করতোয়া মাল্টিমিডিয়া স্কুল এন্ড কলেজ`);
                                this.metaService.updateTag({ name: 'description', content: this.currentContentData.TitleEn || pageTitle });
                                this.metaService.updateTag({ property: 'og:title', content: pageTitle });
                                this.metaService.updateTag({ property: 'og:description', content: this.currentContentData.TitleEn || pageTitle });
                            }
                        } else {
                            // Fallback if no content data but menu exists
                            const pageTitle = this.currentMenuItem.DisplayNameBangla || this.currentMenuItem.MenuName;
                            if (pageTitle) {
                                this.titleService.setTitle(`${pageTitle} | করতোয়া মাল্টিমিডিয়া স্কুল এন্ড কলেজ`);
                            }
                        }
                    }
                }

                this.fetchinData = false;
            }, (error) => {
                console.error("Error fetching data:", error);
                this.fetchinData = false;
            });
    }

    onImageLoad() {
        this.imageLoaded = true;
    }
}
